import PropTypes from 'prop-types'
import SVGIcon from './../../../assets/svgIcons/index'
import {
	CircularProgress,
	CircularProgressLabel,
	IconButton,
	Box,
	Icon,
	Menu,
	MenuButton,
	MenuList,
	MenuGroup,
	MenuItem,
	Tooltip,
} from '@chakra-ui/react'
import { FiEdit } from 'react-icons/fi'

const RAGStatus = ({ activity, onSetPriority, canChangePriority }) => {
	const { activity_rag_status_name, activity_priority_enabled } = activity

	let color = `var(--chakra-colors-gray-200)`
	if (activity_rag_status_name?.match(/red/i))
		color = `var(--chakra-colors-red-500)`
	else if (activity_rag_status_name?.match(/green/i))
		color = `var(--chakra-colors-brand-500)`
	else if (activity_rag_status_name?.match(/amber/i))
		color = `var(--chakra-colors-orange-500)`

	return (
		<>
			<Box position='relative'>
				<CircularProgress value={100} color={color} size='1.65rem'>
					<CircularProgressLabel style={{ left: '45%' }}>
						<SVGIcon
							iconName='flagSvg'
							svgProps={{
								height: '15px',
								viewBox: '0 0 9 14',
							}}
							pathProps={
								activity_priority_enabled === 1
									? { fill: `var(--chakra-colors-red-500)` }
									: {}
							}
						/>
					</CircularProgressLabel>
				</CircularProgress>
				{!!onSetPriority && (
					<>
						<Menu autoSelect={false}>
						<Tooltip hasArrow label='Edit priority' placement='auto' bg='green.600'>
							<MenuButton
								as={IconButton}
								width='1rem'
								minWidth='1rem'
								height='1rem'
								position='absolute'
								top='-5px'
								right='-5px'
								background='white'
								_hover={{
									background: 'white',
								}}
								_active={{
									background: 'white',
								}}
								color='brand.700'
								borderRadius='50%'
								icon={<Icon as={FiEdit} w='0.7rem' h='0.7rem' />}
								disabled={canChangePriority}
								cursor={canChangePriority && 'not-allowed'}
							>
								<IconButton
									aria-label='Edit'
									icon={<Icon as={FiEdit} w='0.7rem' h='0.7rem' />}
									variant='requestSummaryIconButton'
									width='1rem'
									minWidth='1rem'
									height='1rem'
									position='absolute'
									top='-5px'
									right='0'
								/>
							</MenuButton>
							</Tooltip>
							<MenuList
								boxShadow='0px 2px 15px rgba(0, 0, 0, 0.2)'
								borderRadius='10px'
								border='none'
								p='0'
							>
								<MenuGroup
									title='Change Priority'
									bg='brand.600'
									m='0'
									borderTopLeftRadius='10px'
									borderTopRightRadius='10px'
									padding='0.75rem 0 0.5rem 1rem'
									color='white'
									fontWeight='400'
									type='radio'
								>
									<MenuItem
										borderBottom='1px solid #E1E1E1'
										onClick={() => {
											onSetPriority(0)
										}}
										alignItems='center'
									>
										<SVGIcon
											iconName='flagSvg'
											svgProps={{
												height: '15px',
												viewBox: '0 0 9 14',
											}}
										/>
										Low
										{activity_priority_enabled === 0 && (
											<Box ml='auto'>
												<SVGIcon
													iconName='RoundCheckboxIcon'
													svgProps={{
														fill: 'white',
														width: '23',
														height: '23',
														viewBox: '0 0 23 23',
													}}
													isChecked
												/>
											</Box>
										)}
									</MenuItem>
									<MenuItem
										borderBottomLeftRadius='10px'
										borderBottomRightRadius='10px'
										onClick={() => {
											onSetPriority(1)
										}}
										alignItems='center'
									>
										<SVGIcon
											iconName='flagSvg'
											svgProps={{
												height: '15px',
												viewBox: '0 0 9 14',
											}}
											pathProps={{ fill: `var(--chakra-colors-red-500)` }}
										/>
										High
										{activity_priority_enabled === 1 && (
											<Box ml='auto'>
												<SVGIcon
													iconName='RoundCheckboxIcon'
													svgProps={{
														fill: 'white',
														width: '23',
														height: '23',
														viewBox: '0 0 23 23',
													}}
													isChecked
												/>
											</Box>
										)}
									</MenuItem>
								</MenuGroup>
							</MenuList>
						</Menu>
					</>
				)}
			</Box>
		</>
	)
}

RAGStatus.propTypes = {
	activity: PropTypes.object.isRequired,
	onEdit: PropTypes.func,
}

export { RAGStatus }
